import { ListLoadingState } from './state';
import { DISABLE_LOADING, ENABLE_LOADING, ListLoadingAction } from './types';

const initialListLoadingState = { loading: false };
export default function listLoadingReducer(
    listLoading: ListLoadingState = initialListLoadingState,
    action: ListLoadingAction
): ListLoadingState {
    switch (action.type) {
        case ENABLE_LOADING:
            return { loading: true };
        case DISABLE_LOADING:
            return { loading: false };
        default:
            return listLoading;
    }
}
